export const fetch = (filters, headers) => ({
  delayedShipments: {
    value: 1250,
    dataset: [
      {
        name: 'Sun',
        value: 23,
      },
      {
        name: 'Mon',
        value: 55,
      },
      {
        name: 'Tue',
        value: 66,
      },
      {
        name: 'Wed',
        value: 88,
      },
      {
        name: 'Thu',
        value: 99,
      },
      {
        name: 'Fri',
        value: 442,
      },
      {
        name: 'Sat',
        value: 31,
      },
    ],
  },
  deliveredShipments: {
    value: 1800,
    dataset: [
      {
        name: 'Sun',
        value: 23,
      },
      {
        name: 'Mon',
        value: 55,
      },
      {
        name: 'Tue',
        value: 66,
      },
      {
        name: 'Wed',
        value: 88,
      },
      {
        name: 'Thu',
        value: 99,
      },
      {
        name: 'Fri',
        value: 442,
      },
      {
        name: 'Sat',
        value: 31,
      },
    ],
  },
  averageDurationTime: {
    value: 180,
    dataset: [
      {
        name: 'Sun',
        value: 23,
      },
      {
        name: 'Mon',
        value: 55,
      },
      {
        name: 'Tue',
        value: 66,
      },
      {
        name: 'Wed',
        value: 88,
      },
      {
        name: 'Thu',
        value: 99,
      },
      {
        name: 'Fri',
        value: 442,
      },
      {
        name: 'Sat',
        value: 31,
      },
    ],
  },
  exceptions: {
    value: 15,
    dataset: [
      {
        name: 'Sun',
        value: 23,
      },
      {
        name: 'Mon',
        value: 55,
      },
      {
        name: 'Tue',
        value: 66,
      },
      {
        name: 'Wed',
        value: 88,
      },
      {
        name: 'Thu',
        value: 99,
      },
      {
        name: 'Fri',
        value: 442,
      },
      {
        name: 'Sat',
        value: 31,
      },
    ],
  },
  driverRejectedShipments: {
    value: 1150,
  },
  inRoute: {
    value: 1300,
  },
  scheduled: {
    value: 120,
  },
  waitingDriverConfirmation: {
    value: 5,
  },
  driverCancelledShipments: {
    value: 15,
  },
  shipperCancelledShipments: {
    value: 0,
  },
  loading: {
    value: 1800000,
  },
  unloading: {
    value: 4,
  },
  driverDispatched: {
    value: 140,
  },
});
